import { Component, uiElement, uiEvent } from "@kluntje/core";
import { addClass, removeClass, waitFor } from "@kluntje/js-utils/lib/dom-helpers";
import { OPEN } from "Constants/cssClasses";
import FocusService from "Services/FocusService";
import ScrollLockService from "Services/ScrollLockService";

export class SDENavigation extends Component {
  @uiElement(".sde-m-navigation__closing-btn")
  protected closeBtn: HTMLButtonElement;

  @uiElement(".sde-m-navigation__flyout")
  protected flyout: HTMLDivElement;

  public open() {
    addClass(this, OPEN);
    FocusService.trapFocusIn(this);
    ScrollLockService.lockPage();
  }

  @uiEvent("flyout", "click")
  protected handleFlyoutClick(e: MouseEvent) {
    e.stopPropagation();
  }

  @uiEvent("this", "click")
  protected handleOutsideClick() {
    this.close();
  }

  @uiEvent("closeBtn", "click")
  public async close() {
    removeClass(this, OPEN);
    await waitFor(300);
    FocusService.unTrapFocusIn(this);
    ScrollLockService.unlockPage();
  }
}

customElements.define("sde-m-navigation", SDENavigation);
